import { Menu, MenuDropdownProps } from '@mantine/core';
import styled from 'styled-components';

export const QuickSwitchTriggerGroup = styled.div`
	display: inline-flex;
	align-items: center;

	> :first-child {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}

	> :last-child {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		margin-left: -1px;
	}
`;

export const QuickSwitchMenuDropdown = styled(Menu.Dropdown)<MenuDropdownProps>`
	padding: 0.5rem 0;
	border: none;
	${({ theme }) => theme.shadow.z1}
`;

export const QuickSwitchMenuItem = styled.div<{ $isSubItem?: boolean; $isActive?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 0.5rem;
	text-decoration: none;

	cursor: pointer;
	user-select: none;

	box-sizing: border-box;
	padding: 0.5rem;
	margin-left: ${({ $isSubItem }) => ($isSubItem ? '1rem' : '0')};

	border-radius: 4px;
	border: 1px solid ${({ theme }) => theme.v3.colors.white[0]};
	background-color: ${({ theme }) => theme.v3.colors.white[0]};

	&:hover {
		background-color: ${({ theme }) => theme.v3.colors.gray[0]};
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[0]};
	}

	${({ $isActive, theme }) =>
		$isActive &&
		`
		border: 1px solid ${theme.v3.colors.blue[6]};
		background-color: ${theme.v3.colors.blue[0]};

		&:hover {
			background-color: ${theme.v3.colors.blue[0]};
			border: 1px solid ${theme.v3.colors.blue[6]};
		}
	`}
`;
